__turbopack_context__.v({
  "activeIndicator": "page-module__RVtCmW__activeIndicator",
  "bottomCheckoutBar": "page-module__RVtCmW__bottomCheckoutBar",
  "bottomCheckoutBtn": "page-module__RVtCmW__bottomCheckoutBtn",
  "bottomCheckoutInfo": "page-module__RVtCmW__bottomCheckoutInfo",
  "cardQtyBtn": "page-module__RVtCmW__cardQtyBtn",
  "cardQtyControls": "page-module__RVtCmW__cardQtyControls",
  "cardQtyText": "page-module__RVtCmW__cardQtyText",
  "cartBadge": "page-module__RVtCmW__cartBadge",
  "cartBtn": "page-module__RVtCmW__cartBtn",
  "catalogArea": "page-module__RVtCmW__catalogArea",
  "catalogHeader": "page-module__RVtCmW__catalogHeader",
  "dropdownContainer": "page-module__RVtCmW__dropdownContainer",
  "dropdownEmpty": "page-module__RVtCmW__dropdownEmpty",
  "dropdownHeader": "page-module__RVtCmW__dropdownHeader",
  "dropdownItem": "page-module__RVtCmW__dropdownItem",
  "dropdownItemActive": "page-module__RVtCmW__dropdownItemActive",
  "dropdownMenu": "page-module__RVtCmW__dropdownMenu",
  "dropdownOpen": "page-module__RVtCmW__dropdownOpen",
  "dropdownSearchInput": "page-module__RVtCmW__dropdownSearchInput",
  "dropdownSearchWrap": "page-module__RVtCmW__dropdownSearchWrap",
  "emptyIcon": "page-module__RVtCmW__emptyIcon",
  "emptyState": "page-module__RVtCmW__emptyState",
  "fadeIn": "page-module__RVtCmW__fadeIn",
  "filterActive": "page-module__RVtCmW__filterActive",
  "filterChip": "page-module__RVtCmW__filterChip",
  "filterSort": "page-module__RVtCmW__filterSort",
  "filtersWrapper": "page-module__RVtCmW__filtersWrapper",
  "header": "page-module__RVtCmW__header",
  "loadSentinel": "page-module__RVtCmW__loadSentinel",
  "manualScanBtn": "page-module__RVtCmW__manualScanBtn",
  "manualScanForm": "page-module__RVtCmW__manualScanForm",
  "manualScanInput": "page-module__RVtCmW__manualScanInput",
  "posContainer": "page-module__RVtCmW__posContainer",
  "productCard": "page-module__RVtCmW__productCard",
  "productCardList": "page-module__RVtCmW__productCardList",
  "productCount": "page-module__RVtCmW__productCount",
  "productGrid": "page-module__RVtCmW__productGrid",
  "productImagePlaceholder": "page-module__RVtCmW__productImagePlaceholder",
  "productImageThumb": "page-module__RVtCmW__productImageThumb",
  "productInfo": "page-module__RVtCmW__productInfo",
  "productList": "page-module__RVtCmW__productList",
  "productName": "page-module__RVtCmW__productName",
  "productPrice": "page-module__RVtCmW__productPrice",
  "productStock": "page-module__RVtCmW__productStock",
  "scanBtn": "page-module__RVtCmW__scanBtn",
  "scanHistoryActions": "page-module__RVtCmW__scanHistoryActions",
  "scanHistoryEmpty": "page-module__RVtCmW__scanHistoryEmpty",
  "scanHistoryItem": "page-module__RVtCmW__scanHistoryItem",
  "scanHistoryList": "page-module__RVtCmW__scanHistoryList",
  "scanHistoryMeta": "page-module__RVtCmW__scanHistoryMeta",
  "scanHistoryNotFound": "page-module__RVtCmW__scanHistoryNotFound",
  "scanHistoryTitle": "page-module__RVtCmW__scanHistoryTitle",
  "scanHistoryWrap": "page-module__RVtCmW__scanHistoryWrap",
  "scannerCloseBtn": "page-module__RVtCmW__scannerCloseBtn",
  "scannerError": "page-module__RVtCmW__scannerError",
  "scannerHeader": "page-module__RVtCmW__scannerHeader",
  "scannerHint": "page-module__RVtCmW__scannerHint",
  "scannerModal": "page-module__RVtCmW__scannerModal",
  "scannerOverlay": "page-module__RVtCmW__scannerOverlay",
  "scannerRetryBtn": "page-module__RVtCmW__scannerRetryBtn",
  "scannerVideo": "page-module__RVtCmW__scannerVideo",
  "searchClearBtn": "page-module__RVtCmW__searchClearBtn",
  "searchIcon": "page-module__RVtCmW__searchIcon",
  "searchInput": "page-module__RVtCmW__searchInput",
  "searchWrapper": "page-module__RVtCmW__searchWrapper",
  "title": "page-module__RVtCmW__title",
  "viewBtn": "page-module__RVtCmW__viewBtn",
  "viewBtnActive": "page-module__RVtCmW__viewBtnActive",
  "viewToggle": "page-module__RVtCmW__viewToggle",
});
